import React from 'react'
import poweredByRuckusUrl from './PoweredByRuckus.png'

export { ReactComponent as QrCodeSmallIcon } from './QrCodeSmall.svg'
export { ReactComponent as PoweredBy } from './PoweredBy.svg'
const poweredByRuckusStyle: React.CSSProperties = {
  maxHeight: 140,
  width: 'auto',
  objectFit: 'contain'
}

export const PoweredByRuckus = () =>
  React.createElement('img', {
    src: poweredByRuckusUrl,
    alt: 'Powered by Ruckus Networks',
    style: poweredByRuckusStyle
  })
export { ReactComponent as CancelCircleSolid } from './CancelCircleSolid.svg'
export { ReactComponent as WarningCircleSolid } from './WarningCircleSolid.svg'
export { ReactComponent as Wifi4euBanner } from './Wifi4euBanner.svg'
export { ReactComponent as CopyOutlined} from './CopyOutlined.svg'
export { ReactComponent as EmailOutlined} from './emailOutlined.svg'
export { ReactComponent as SmsOutlined} from './smsOutlined.svg'
export { ReactComponent as EyeOpenSolid} from './EyeOpenSolid.svg'
export { ReactComponent as EyeSlashSolid} from './EyeSlashSolid.svg'